import React from 'react';
import './App.css';
import Router from './Router';

function App() {
  return (
     <main>
       <Router />
     </main>
  )
}

export default App;
